<template>
  <div class="index-box">
    <div class="indexTopBox">
      <!-- 合作交流 -->
      <div class="imageListCardVideo">
        <img class="qiyeImg" :src="schoolList.imgPath" />
        <div>{{ schoolList.companyName }}</div>
        <div>校友：{{ schoolList.alumniName }}</div>
        <div class="card_tail" v-if="fengeList != ''">
          <div
            class="card_tail_content"
            v-for="(segment, index) in fengeList"
            :key="index"
          >
            {{ segment }}
          </div>
        </div>
      </div>
    </div>
    <div class="indexBtn" v-show="schoolList.num == 0" @click="onDocking">
      我要对接
    </div>

    <van-action-sheet v-model="docking" title="我要对接">
      <el-form
        :model="dockingForm"
        ref="dockingForm"
        style="padding: 0 20px 0 20px"
        :rules="dockingRules"
      >
        <el-form-item label="联系人" prop="name">
          <el-input
            v-model="dockingForm.name"
            placeholder="请输入联系人"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input
            v-model="dockingForm.phone"
            placeholder="请输入电话"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="合作意向" prop="content">
          <el-input
            v-model="dockingForm.content"
            placeholder="请输入合作意向"
            type="textarea"
            rows="8"
            maxlength="200"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="formDivBtnDiv">
        <button class="formDivBtn" @click="submit">提交</button>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import btnGuankan from "@/assets/image/btn_guankan_nor.png";

export default {
  data() {
    return {
      btnGuankan,
      schoolList: [],
      id: this.$route.query.id,
      userId: window.localStorage.getItem("user_id"),
      // userId: "43995354",
      docking: false,
      dockingForm: {},
      dockingRules: {
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入电话号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入合作意向", trigger: "blur" },
        ],
      },
      fengeList: [],
    };
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    // 合作交流获取--详情
    async getSchoolList() {
      const result = await this.$http.get(
        "/schoolEnterprise/getDetailEnterprise",
        {
          params: { id: this.id, userId: this.userId },
        }
      );
      this.schoolList = result.data;
      console.log("合作交流获取-详情", this.schoolList);

      // 使用split方法根据关键字分割字符串
      const content = result.data.intro.split("\n");
      // 重新组合分段，包含关键字
      const contentList = [];
      for (let i = 0; i < content.length; i++) {
        contentList.push(content[i]);
      }
      this.fengeList = contentList;
    },
    onDocking() {
      this.docking = true;
    },

    submit() {
      this.$refs.dockingForm.validate(async (valid) => {
        if (!valid) {
          return;
        }

        this.dockingForm.userId = this.userId;
        this.dockingForm.companyId = this.id;
        const result = await this.$http({
          url: "/schoolEnterprise/sendCompany",
          method: "POST",
          params: this.dockingForm,
        });

        if (result.data.提交成功 == true) {
          this.docking = false;
          this.$toast("提交成功");
          this.getSchoolList();
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  margin-top: 0px;
  .indexTopBox {
    width: 95vw;
    height: 86vh;
    position: relative;
    // margin-top: 1px;
    margin-left: 2.5vw;
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
  }
  .indexBtn {
    position: fixed;
    width: 100vw;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #00706e;
    color: #fff;
    margin-top: 30px;
    bottom: 0px;
  }

  .qiyeImg {
    display: flex;
    width: 100%;
    border-radius: 1rem;
    height: 15rem;
    margin-top: 10px;
    border: 1px solid #dbdbdb;
    image-rendering: -webkit-optimize-contrast;
  }
}

.imageListCardVideo :nth-child(2) {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 10px;
}
.imageListCardVideo :nth-child(3) {
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 5px;
  color: #818181;
}

.card_tail {
  width: 95vw;
  border-radius: 10px;
  background-color: #ffffff;
  margin-top: 10px;
  padding: 5px 0 5px 0;
  bottom: 20px;
  .card_tail_content {
    font-size: 1rem;
    font-weight: 500;
    line-height: 25px; //行间距
    color: #747474;
    text-indent: 4ch; //首行缩进
    text-align: justify; //两端对齐
    padding: 0 1rem 0 1rem;
  }
}

.formDivBtnDiv {
  margin-bottom: 20px;

  .formDivBtn {
    width: 90%;
    border: 0;
    margin-left: 5%;
    border-radius: 30px;
    font-size: 1.2rem;
    color: white;
    font-weight: bold;
    padding: 10px 0;
    background: linear-gradient(270deg, #00706e, #00706e);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/SchoolDetaile.vue